import { useQContent } from '@exam-management/common/qcontent-provider';
import { useExportSingleQuestionMutation } from '@exam-management/graphql';
import { Dialog, DialogTitle, Divider, type DialogProps } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';

import { QuestionExportForm, type QuestionExportFormInput } from '../../components';
import { QuestionExportFileTemplate } from '../../constants';

interface QuestionExportModalProps extends DialogProps {
  onClose: () => void;
  open: boolean;
}

export default function QuestionExportModal(props: Readonly<QuestionExportModalProps>) {
  const { onClose, open: isOpen } = props;

  const [exportSingleQuestion] = useExportSingleQuestionMutation();
  const { qContent } = useQContent();
  const { showSnackbar } = useSnackbar();

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = async (data: QuestionExportFormInput) => {
    const hasSolution =
      data.template === QuestionExportFileTemplate.QUESTION_WITH_CHOICES_AND_SOLUTION;

    await exportSingleQuestion({
      variables: {
        input: {
          questionId: qContent.id,
          format: data.fileType,
          includeSolution: hasSolution,
        },
      },
      onCompleted: () => {
        showSnackbar({
          message: 'Export Successfully',
          variant: 'success',
        });
        onClose();
      },
      onError: () => {
        showSnackbar({
          message: 'Export Failed',
          variant: 'error',
        });
      },
    });
  };

  return (
    <Dialog open={isOpen} maxWidth='sm' onClose={handleClose}>
      <DialogTitle onClose={onClose}>Export Question</DialogTitle>
      <Divider />
      <QuestionExportForm onSubmit={handleSubmit} onClose={handleClose} />
    </Dialog>
  );
}
